import { ModuleType } from "entities/modules/types";
import ContentBlocks from "./components/ContentBlocks";
import Games from "./components/Games";
import MarqueeCards from "./components/MarqueeCards";
import PrivacyTips from "./components/PrivacyTips";
import Promotions from "./components/Promotions";
import Studios from "./components/Studios";
import TopWinners from "./components/TopWinners";

export const ModuleComponentMap: Record<
  ModuleType,
  React.ComponentType<any>
> = {
  [ModuleType.Games]: Games,
  [ModuleType.Studios]: Studios,
  [ModuleType.MarqueeCards]: MarqueeCards,
  [ModuleType.ContentBlocks]: ContentBlocks,
  [ModuleType.Promotion]: Promotions,
  [ModuleType.RecentlyPlayed]: Games,
  [ModuleType.FavouriteGames]: Games,
  [ModuleType.RecentWithdrawals]: Games,
  [ModuleType.TopWinners]: TopWinners,
  [ModuleType.TopPrivacyTips]: PrivacyTips,
  [ModuleType.ProductIframe]: () => null,
};

export const ModuleHeightMap: Record<ModuleType, number> = {
  [ModuleType.Games]: 277,
  [ModuleType.Studios]: 88,
  [ModuleType.MarqueeCards]: 215,
  [ModuleType.ContentBlocks]: 88,
  [ModuleType.Promotion]: 275,
  [ModuleType.RecentlyPlayed]: 277,
  [ModuleType.FavouriteGames]: 277,
  [ModuleType.RecentWithdrawals]: 277,
  [ModuleType.TopWinners]: 88,
  [ModuleType.TopPrivacyTips]: 88,
  [ModuleType.ProductIframe]: 88,
};

export const ENTERING_MODULE_ANIMATION_DURATION = 11000;
